import React from 'react';
import { WeatherConditions } from 'apollo/generated/client-operations';

export type WeatherItemMiniProps = {
  weather: WeatherConditions;
};

export function WeatherItemMini({
  weather,
}: WeatherItemMiniProps): React.ReactElement {
  const { description, icon, temp } = weather;
  return (
    <div className="odin-flex odin-flex-row odin-w-auto odin-items-center">
      <img src={icon} alt={description} width={32} height={32} />
      <div className="odin-text-odin-black odin-text-xs">{`${Math.round(
        temp,
      )}°`}</div>
    </div>
  );
}
